import { useEffect } from "react";

export default function Loading() {
  useEffect(() => {
    const timer = setTimeout(() => location.reload(), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block w-6 h-6 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
        <p className="mt-4 text-sm text-slate-500">データを読み込んでいます</p>
      </div>
    </div>
  );
}
